import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import register1Image from "../../../assets/images/home/register1.jpeg";
import { FiEye, FiEyeOff, FiArrowRight } from "react-icons/fi";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import "../../../assets/css/equipmentrentaladmin/register/Register.css";
import AppContext from "../../../context/AppContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const { baseUrl, setAuthToken, setIsLoggedIn, setLoggedInRental, setLoggedInCustomer } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errormessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const rentalLogin = () => {
    if (!email || !password) {
      setErrorMessage("Email and password required");
      return;
    }
    setLoading(true);

    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);

    axios.post(`${baseUrl}/rentaladmin/authentication/rentalLogin`, formdata)
      .then((response) => {
        setLoading(false);
        localStorage.setItem("authToken", response.data.token);
        setAuthToken(response.data.token);
        setIsLoggedIn(true);
        localStorage.removeItem("LoggedInCustomer");
        setLoggedInCustomer(null);
        setLoggedInRental(response.data.rentaladmin);
        localStorage.setItem("LoggedInRental", JSON.stringify(response.data.rentaladmin));

        const redirectUrl = localStorage.getItem("redirectAfterLogin");
        if (redirectUrl) {
          localStorage.removeItem("redirectAfterLogin");
          navigate(redirectUrl);
        } else {
          navigate("/rental-admin/dashboard");
        }
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 404) {
          setErrorMessage("Account not registered. Redirecting to registration...");
          setTimeout(() => navigate("/rental-admin/registration"), 2000);
        } else if (error.response?.status === 401) {
          setErrorMessage("Invalid Email or Password");
        } else {
          setErrorMessage("Login failed, please try again");
        }
      });
  };

  return (
    <div className="fleet-container">
      <div className="fleet-left"
        style={{
          backgroundImage: `url(${register1Image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}>
        <div className="fleet-left-overlay" />
        <div className="fleet-left-content">
          <span className="owner-badge">FOR EQUIPMENT OWNERS</span>
          <h1>Welcome <br /> Back!</h1>
          <p>
            Log in to manage your agricultural equipment fleet, track rentals,
            and monitor performance all in one place.
          </p>
        </div>
      </div>

      <div className="fleet-right">
        <div className="reg-form-wrapper">
          <div className="reg-form-card">
            <h2>Login to Your Account</h2>
            <p>Enter your credentials to access your dashboard.</p>

            <form>
              <div className="reg-form-group">
                <label>Email Address</label>
                <div className="reg-input-wrapper">
                  <input
                    type="email"
                    placeholder="name@company.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="reg-form-group">
                <label>Password</label>
                <div className="reg-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button type="button" className="eye-btn" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
                {errormessage && (
                  <p style={{ color: "red", fontSize: "0.8rem", marginTop: "6px" }}>
                    {errormessage}
                  </p>
                )}
                <p style={{ textAlign: "right", marginTop: "8px" }}>
                  <span
                    onClick={() => navigate("/general/forgot-password/rentaladmin")}
                    style={{
                      color: "#FDB714",
                      fontWeight: "600",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontSize: "0.85rem",
                    }}
                  >
                    Forgot Password?
                  </span>
                </p>
              </div>

              <button
                type="button"
                className="submit-btn"
                onClick={rentalLogin}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                    Logging In...
                  </>
                ) : (
                  <>
                    Login <FiArrowRight />
                  </>
                )}
              </button>

              <p style={{
                textAlign: "center",
                marginTop: "18px",
                fontSize: "0.875rem",
                color: "#555",
                fontFamily: "'Poppins', sans-serif"
              }}>
                Don't have an account?{" "}
                <span
                  onClick={() => navigate("/rental-admin/registration")}
                  style={{
                    color: "#FDB714",
                    fontWeight: "600",
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                >
                  Sign Up
                </span>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}